import { ThemeOptions } from '@mui/material';

import * as Colors from '../colors';

export const skeletonThemeOptions: ThemeOptions = {
  components: {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          opacity: '0.6',
          bgcolor: `${Colors.grey[50]}`,
        },
      },
    },
  },
};
